import React from 'react'
import {Button, Label} from '@therms/atalaya'
import {RefsByTypesFields} from '@src/modules/Reports/shared/components/RefsByTypesFields'
import {RPCDocs} from '@therms/react-modules'

interface EditReportRefsProps {
  actionLabel: string
  allowedRefs: RPCDocs.Reports.GetReport.v1.RefsConfig
  onChangeValue: (newValue: RPCDocs.Reports.GetReport.v1.RefsByType) => void
  onComplete: () => void
  value: RPCDocs.Reports.GetReport.v1.RefsByType
}

function EditReportRefs({
  actionLabel,
  allowedRefs,
  onChangeValue,
  onComplete,
  value,
}: EditReportRefsProps) {
  const handleRefChange = (key: string, newValue: typeof value) => {
    onChangeValue({...value, [key]: newValue})
  }

  return (
    <div className="gap-y-lg flex flex-col">
      <div>
        <Label>Add Report References</Label>

        <div>
          <small className="text-color-neutral">
            References create a link to the Report. Any and all associations or
            relevant refs should be added below.
          </small>
        </div>
      </div>

      <RefsByTypesFields
        allowedRefs={allowedRefs}
        onRefValueChange={handleRefChange}
        value={value}
      />

      <div className="inline-flex justify-end">
        <Button onClick={onComplete}>{actionLabel || 'Done'}</Button>
      </div>
    </div>
  )
}

export {EditReportRefs}